import { Stack } from 'expo-router';
import rdcStrings from 'features/rdc/rdcStrings.en';
import { TFunction } from 'i18next';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import ContentList from 'shared/components/vxl/ContentList/ContentList';
import ErrorScreen, {
  ErrorScreenType,
} from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import theme from 'shared/styles/theme';

interface DepositCheckFixableViewProps {
  errors: string[];
  translatedText: TFunction<'rdc', undefined>;
  handleUpdateCheckDetailsAction: () => void;
  handleCancelAction: () => void;
}

const DepositCheckFixableView = ({
  errors,
  translatedText,
  handleUpdateCheckDetailsAction,
  handleCancelAction,
}: DepositCheckFixableViewProps) => {
  const { outcome } = rdcStrings;

  return (
    <View style={baseStyles.container} accessible>
      <Stack.Screen
        options={{
          headerShown: false,
        }}
      />
      <ErrorScreen
        screenType={ErrorScreenType.Warning}
        messageHeadline={translatedText(
          'outcome.fixable.title',
          outcome.fixable.title,
        )}
        content={<ContentList contentList={errors} />}
        primaryButton={{
          title: translatedText(
            'outcome.fixable.buttons.updateCheckDetails',
            outcome.fixable.buttons.updateCheckDetails,
          ),
          onPress: handleUpdateCheckDetailsAction,
        }}
        secondaryButton={{
          title: translatedText(
            'outcome.fixable.buttons.cancel',
            outcome.fixable.buttons.cancel,
          ),
          onPress: handleCancelAction,
        }}
      />
    </View>
  );
};

const baseStyles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
});

export default DepositCheckFixableView;
